// extracted by mini-css-extract-plugin
export default {"separator":"section-module___separator___bd55c417"};